import { get, set } from 'idb-keyval'

export const saveContactActivity = async (
  userId: string,
  userEnv: string,
  contactId: string
) => {
  try {
    const key = `${userId}__${userEnv}__contacts`
    const val = await get(key)
    if (val) {
      const newVals = val.filter(x => x !== contactId)
      const newValsToSave = [contactId, ...newVals]
      await set(key, newValsToSave.slice(0, 5))
      return
    } else {
      const newVal = [contactId]
      await set(key, newVal)
    }
  } catch (err) {
    console.error(`error saving contacts activity! ${err}`)
  }
}

export const saveTaskActivity = async (
  userId: string,
  userEnv: string,
  taskId: string
) => {
  try {
    const key = `${userId}__${userEnv}__tasks`
    const val = await get(key)
    if (val) {
      const newVals = val.filter(x => x !== taskId)
      const newValsToSave = [taskId, ...newVals]
      await set(key, newValsToSave.slice(0, 5))
      return
    } else {
      const newVal = [taskId]
      await set(key, newVal)
    }
  } catch (err) {
    console.error(`error saving tasks activity! ${err}`)
  }
}

export const getTaskActivity = async (userId: string, userEnv: string) => {
  try {
    const key = `${userId}__${userEnv}__tasks`
    return (await get(key)) ?? []
  } catch (err) {
    console.error(`error getting task activity! ${err}`)
  }
}

export const getContactsActivity = async (userId: string, userEnv: string) => {
  try {
    const key = `${userId}__${userEnv}__contacts`
    return (await get(key)) ?? []
  } catch (err) {
    console.error(`error getting contacts activity! ${err}`)
  }
}
